import { FC } from 'react';

export const SettingsTabPage: FC = () => {
	return <div>SettingsTabPage</div>;
};
